import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import Text from '../../ui/Text'

export const SContainer = styled.div<{ size?: 'sm' | 'md' | 'lg' }>`
    font-weight: var(--font-weight-bold);
    font-size: ${({ size }) => {
        if (size === 'sm') return '1rem'
        if (size === 'md') return '1.25rem'
        else return '2rem'
    }};
    display: flex;
    align-items: center;
    gap: 5px;
    width: 50%;
    max-width: 50%;

    @media (max-width: ${({ theme }) => theme.breakPoints.xl}) {
        width: 100%;
        max-width: 100%;
    }
`

const SHeader = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
`

const SMessage = styled.div`
    font-weight: var(--font-weight-normal);
`

export type HeaderProps = {
    code?: string
    message?: string
    dataTestId?: string
    className?: ClassName
    style?: React.CSSProperties
    loading?: boolean
    size?: 'sm' | 'md' | 'lg'
}

export function Header({
    code,
    message,
    className,
    style,
    loading,
    size = 'md',
    dataTestId,
}: HeaderProps): React.ReactElement {
    return (
        <SContainer style={style} size={size}>
            <SHeader className={cn(className)} data-testid={dataTestId ?? 'header'}>
                {code && <Text code={code} />}
                {message && <SMessage>{message}</SMessage>}
                {loading && (
                    <FontAwesomeIcon icon={faSpinner} pulse className="aweFontSizeSmall" data-testid="spinner" />
                )}
            </SHeader>
        </SContainer>
    )
}
